import ActivityLog from '../pages/Activity/ActivityLog';
import { STAFF_ABOVE } from '../constants/roles';
import RoleProtectedRoute from '../components/RoleProtectedRoute';
import type { AppRoute } from './types';

export const activityRoutes: AppRoute[] = [
    { path: 'activity', element: <RoleProtectedRoute allowedRoles={STAFF_ABOVE} Component={ActivityLog} /> },
];
